import React from 'react';
import ProjectCard from '../common/ProjectCard';
import { projects } from '../../data/projects';

export default function Projects() {
  return (
    <section id="work" className="min-h-screen px-4 md:px-6 py-20">
      <div className="max-w-6xl mx-auto w-full">
        <h2 className="text-4xl md:text-5xl lg:text-7xl font-light mb-12 md:mb-20">Work</h2>
        <div className="space-y-12 md:space-y-16">
          {projects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
}